<div *ngIf="isSuccess" class="flex justify-center gap-4">
  <button
    mat-raised-button
    class="px-4 py-2 bg-brand-surface-muted text-brand-text-secondary hover:bg-brand-border-mutedtext-sm rounded-md"
    (click)="volver()"
  >
    Volver
  </button>

  <button
    mat-raised-button
    class="bg-brand-primary text-brand-surface px-4 py-2 rounded-md hover:bg-brand-primary-hover text-sm disabled:opacity-50 disabled:cursor-not-allowed"
    (click)="getPDF()"
  >
    Generar PDF
  </button>
</div>

<div *ngIf="isSuccess" id="infoPdf" class="pdf-wrapper">
  <div #pdfContent>
    <div class="pdf-template">
      <div id="watermark" class="watermark">DOCUMENTO INFOMÁTIVO</div>
      <title>Acta de Cálculo de Aporte</title>
      <div class="header">
        <div style="flex: 0 0 120px">
          <img
            [src]="cfg.project.logo"
            [alt]="'Logo ' + cfg.project.name"
            style="max-width: 200px"
          />
        </div>
        <div class="cuadro-solicitud">
          <div class="row-title">Folio</div>
          <div class="row-value">
            {{ dataId }}
          </div>
          <div class="row-title">Fecha Ingreso</div>
          <div class="row-value">
            {{ expediente_info?.actaAporte?.fechaCreacion }}
          </div>
          <div class="row-title">Fecha Emisión</div>
          <div class="row-value">
            {{ expediente_info?.actaAporte?.fechaEmision }}
          </div>
          <div class="row-title">Fecha Cálculo</div>
          <div class="row-value">
            {{ expediente_info?.actaAporte?.fechaCalculo }}
          </div>
          <div class="row-title">Caja</div>
          <div class="row-value">
            {{ expediente_info?.actaAporte?.caja }}
          </div>
        </div>
      </div>

      <div class="header-center">
        <h1>CÁLCULO DE DERECHOS</h1>
        <h1>MUNICIPALES DE EDIFICACIÓN</h1>
        <h1>LEY 20.958</h1>
        <div class="subtitulo-copiapo">
          <p>Aporte al Espacio Público</p>
          <p>DIRECCIÓN DE OBRAS MUNICIPALES</p>
          <p><strong>I. MUNICIPALIDAD DE TALCA</strong></p>
        </div>
      </div>
      <br />

      <!-- ====== DATOS DEL EXPEDIENTE ====== -->
      <div class="datos-expediente">
        <div class="row-title">Expediente:</div>
        <div class="row-value">
          {{ expediente_info?.expediente }}
        </div>

        <div class="row-title">Propietario:</div>
        <div class="row-value">
          {{
            expediente_info?.profesionales?.propietario
              ? expediente_info?.profesionales?.propietario
              : ""
          }}
        </div>

        <div class="row-title">Representante:</div>
        <div class="row-value">
          {{
            expediente_info?.profesionales?.representante
              ? expediente_info?.profesionales?.representante
              : ""
          }}
        </div>

        <div class="row-title">Arquitecto:</div>
        <div class="row-value">
          {{
            expediente_info?.profesionales?.arquitecto
              ? expediente_info?.profesionales?.arquitecto
              : ""
          }}
        </div>

        <div class="row-title">Ubicación:</div>
        <div class="row-value">
          {{ expediente_info?.propiedad ? expediente_info?.propiedad : "" }}
        </div>

        <div class="row-title">ROL:</div>
        <div class="row-value">
          {{ expediente_info?.rol ? expediente_info?.rol : "" }}
        </div>

        <div class="row-title">Materia:</div>
        <div class="row-value">
          {{ expediente_info?.tipoTramite ? expediente_info?.tipoTramite : "" }}
        </div>

        <div class="row-title">Tema:</div>
        <div class="row-value">
          {{ expediente_info?.temaTramite ? expediente_info?.temaTramite : "" }}
        </div>
      </div>
      <br />
      <!-- ===== BLOQUE CEDE Y PAGA ===== -->
      <div>
        <div class="calculo-header">
          <strong
            >CÁLCULO DE DERECHOS MUNICIPALES DE ACUERDO AL ART. 2.2.5 BIS DE LA
            O.G.U.C.</strong
          >
        </div>
        <br />

        <!-- SECCIÓN 1 -->
        <div class="seccion">
          <div class="linea-titulo">
            <span class="titulo">1. CÁLCULO DE % DE TERRENO A CEDER:</span>
            <span class="row-value justify-center" style="width: 30%">
              {{
                aporteStatus === "CEDE Y PAGA"
                  ? "CEDE Y PAGA CORRESPONDE"
                  : aporteStatus === "NO"
                  ? "NO CORRESPONDE"
                  : aporteStatus === "SI"
                  ? "SI CORRESPONDE"
                  : ""
              }}
            </span>
          </div>

          <p class="subtitulo" style="font-weight: bold">OBSERVACIONES:</p>

          <p class="texto">
            {{ expediente_info?.actaAporte?.correspondeEdit }}
          </p>

          <br />
          <p class="nota">
            <em>
              El monto del valor del aporte debe estar cancelado antes de la
              recepción Municipal de la obra autorizada. (Artículo 2.2.5 bis D,
              de la Ordenanza General de Urbanismo y Construcciones)
            </em>
          </p>
        </div>
        <br />
        <div class="linea-titulo">
          <span class="titulo">2. CÁLCULO DE % DE TERRENO A CEDER:</span>
        </div>
        <!-- SECCIÓN 2 -->
        <div class="seccion">
          <table class="tabla-aporte">
            <tr class="fila">
              <td class="label">AVALÚO FISCAL TERRENO X % DE APORTE A CEDER</td>
              <td
                class="valor"
                style="text-align: center; vertical-align: middle"
              >
                {{ expediente_info?.actaAporte?.avaluoIncrementado }} X
                {{ expediente_info?.actaAporte?.porcentajeCesion }}
              </td>
            </tr>
            <tr class="fila">
              <td class="label">% DE APORTE A CEDER</td>
              <td
                class="valor"
                style="text-align: center; vertical-align: middle"
              >
                {{ expediente_info?.actaAporte?.porcentajeCesion }}
              </td>
            </tr>
            <tr class="fila total">
              <td class="label">
                <strong>TOTAL A PAGAR POR LEY 20.958</strong>
              </td>
              <td
                class="valor"
                style="text-align: center; vertical-align: middle"
              >
                <strong>{{ expediente_info?.actaAporte?.valorAPagar }}</strong>
              </td>
            </tr>
          </table>

          <p class="nota">
            <em>
              De acuerdo a la Ley 20.958, este valor deberá ser cancelado antes
              de la recepción definitiva de la obra.
            </em>
          </p>
        </div>
        <br />
        <div class="calculo-header">
          <strong>NOTAS</strong>
          <p class="texto">
            {{ expediente_info?.actaAporte?.nota }}
          </p>
        </div>
      </div>

      <!-- ====== FIRMAS ====== -->
      <div class="firmas-container">
        <div class="firma-item">
          <img
            *ngIf="firmaUrlArquitecto"
            [src]="firmaUrlArquitecto"
            alt="Firma funcionario"
            class="firma-img"
          />
          <div class="firma-texto">
            <p class="firma-multilinea">
              <strong>
                {{ expediente_info?.actaAporte?.firmas?.revisor?.nombre }}
              </strong>
            </p>
          </div>
        </div>

        <div class="firma-item derecha">
          <img
            [src]="firmaUrlDirector || 'assets/firmas/director.png'"
            alt="Firma director"
            class="firma-img"
          />
          <div class="firma-texto">
            <p class="firma-multilinea">
              <strong>
                {{ expediente_info?.actaAporte?.firmas?.director?.nombre }}
              </strong>
            </p>
          </div>
        </div>
      </div>

      <!-- <div class="nota-abreviaturas mb-12">
        <p><strong>NOTA:</strong> Las abreviaturas indicadas corresponden a:</p>
        <div class="abreviaturas-grid">
          <ul>
            <li>
              <strong>- C.I.P.:</strong> Certificado de informaciones previas
            </li>
            <li><strong>- P.R.C.:</strong> Plan regulador comunal</li>
            <li><strong>- N.N.T.:</strong> Nivel natural de terreno</li>
          </ul>
          <ul>
            <li>
              <strong>- O.G.U.C.:</strong> Ordenanza general de urbanismo y
              construcciones
            </li>
            <li>
              <strong>- L.G.U.C.:</strong> Ley general de urbanismo y
              construcciones
            </li>
            <li><strong>- A.U.P.:</strong> Afectación a utilidad pública</li>
          </ul>
        </div>
      </div> -->
    </div>
  </div>
</div>

<html *ngIf="!isSuccess" class="h-full w-full m-0 p-0">
  <head>
    <meta charset="UTF-8" />
    <script src="https://cdn.tailwindcss.com"></script>
    <title>No accesible</title>
  </head>
  <body
    class="fixed inset-0 m-0 p-0 flex items-center justify-center bg-gray-100"
  >
    <div class="bg-white rounded-lg shadow-md p-8 text-center max-w-md">
      <div class="flex justify-center mb-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-10 w-10 text-red-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </div>

      <h1 class="text-lg font-semibold text-gray-800 mb-2">
        No es posible acceder a este contenido
      </h1>
      <p class="text-gray-600 text-sm">
        Puede que no tengas los permisos necesarios o el recurso ya no esté
        disponible.
      </p>
    </div>
  </body>
</html>

<p-toast [life]="4000" position="top-right" styleClass="z-[10000]"></p-toast>
